// capabilities - what the submit page offers beyond an upload.
//
// The dashboard offers everything, and with no provider that is what the
// submit page gets. An app that hosts the page in front of a narrower API
// supplies its own value, and a way in its API cannot serve is not offered
// at all, rather than offered and broken on the first click.

import { createContext, type ReactNode, useContext } from 'react';

export interface SubmitCapabilities {
  /** The "Search an identifier" tab: looking a hash, URL, IP address or
   *  domain up in the intelligence sources before anything runs. */
  identifierSearch: boolean;
}

const EVERYTHING: SubmitCapabilities = { identifierSearch: true };

const SubmitCapabilitiesContext = createContext<SubmitCapabilities>(EVERYTHING);

export function SubmitCapabilitiesProvider({ value, children }: { value: SubmitCapabilities; children: ReactNode }) {
  return <SubmitCapabilitiesContext.Provider value={value}>{children}</SubmitCapabilitiesContext.Provider>;
}

export function useSubmitCapabilities(): SubmitCapabilities {
  return useContext(SubmitCapabilitiesContext);
}
